import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import {isMobile} from 'react-device-detect';
import Config from 'app/Config';
import {
  sendEntityPaymentML,
  selectEpiData,
  selectEntityPaymentPhoneNumber,
  selectServerData,
  setEntityPaymentPhoneNumber,
} from '../DebtAndUpdatePaymentBlockSlice';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';
import {regexPatterns, validationRules} from 'app/utilities/validation/validationVariables';
import Image from 'app/Components/Shared/Image/image';
import useEnterKeyPress from '../hooks/useEnterKeyPress';

const SendSmsEntityPayment = () => {
  const dispatch = useDispatch();
  const [isAgreed, setIsAgreed] = useState(false);
  const [error, setError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [isInputFocused, setIsInputFocused] = useState(false);
  const epiData = useSelector(selectEpiData);
  const phoneNumber = useSelector(selectEntityPaymentPhoneNumber);
  const selectedBansForPaymentUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);
  const allBans = useSelector(selectServerData);
  let regex = new RegExp(regexPatterns.phoneRegex);

  const handlePhoneChange = (e) => {
    const limitedValue = e.target.value.replace(/\D/g, '').slice(0, 10);
    dispatch(setEntityPaymentPhoneNumber(limitedValue));
    if (phoneError) {
      setPhoneError('');
    }
  };

  const getSelectedBansForPayment = () => {
    return (selectedBansForPaymentUpdate ?? [])
      .map((banNumber) => {
        const ban = allBans.find((item) => item.banNumber === banNumber);
        if (!ban) {
          return null;
        }

        return {
          number: banNumber,
          name: ban.productDescriptions ?? '',
        };
      })
      .filter(Boolean);
  };

  const handleSendSMS = async () => {
    if (!phoneNumber) {
      setError('כדי להתקדם יש להזין מספר טלפון');
      return;
    }

    if (phoneNumber.length < 10) {
      setPhoneError(validationRules.phone.minLength.error);
      return;
    }

    if (!regex.test(phoneNumber)) {
      setPhoneError('מספר הטלפון חייב להתחיל ב-05 ולהכיל 10 ספרות');
      return;
    }

    if (!isAgreed) {
      setError('כדי להתקדם יש לאשר תנאי שימוש');
      return;
    }

    const checkedItems = getSelectedBansForPayment();
    const jsonString = JSON.stringify(checkedItems);
    dispatch(
      sendEntityPaymentML({
        phoneNumber,
        banNumberList: jsonString,
      }),
    );
  };
  useEnterKeyPress(handleSendSMS, false);

  return (
    <div className='debtpayment-step send-sms-entity-payment-step'>
      <div className='send-sms-entity-payment-content'>
        <Image src={require('../images/credit_card_entity.svg')} alt='payment icon' />
        <div className='l-title'>מי ישלם את החשבון?</div>
        <div className={`m-title ${isMobile ? 's-title-small' : 'm-title'}`}>
          לאחר האישור, ישלח SMS למספר שהוזן לצורך
          <br /> הגדרת פרטי כרטיס האשראי החדש
        </div>

        <div className='phone-input-wrapper'>
          <TextInput
            type='text'
            placeholder='מספר הטלפון של מי שישלם'
            value={phoneNumber}
            onChange={handlePhoneChange}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
            error={phoneError}
            maxLength='10'
            inputMode='numeric'
            autoComplete='tel'
            required={true}
          />

          {epiData.serviceTermsLink && (
            <div className='agreement-container'>
              <CheckBox
                id='send-sms-entity-payment-agreement'
                checked={isAgreed}
                onCheck={() => {
                  setIsAgreed(true);
                  if (error) {
                    setError('');
                  }
                }}
                onUncheck={() => setIsAgreed(false)}
                label={
                  <>
                    אישור{' '}
                    <a onClick={() => buildUrlAndOpenWindow(epiData.serviceTermsLink)} className='primaryColor btn-link'>
                      תנאי השימוש
                    </a>
                  </>
                }
                customClassName='square'
              />
            </div>
          )}
        </div>
      </div>
      <div className='continue-button'>
        {error && <div className='error'>{error}</div>}
        <BtnSubmit text='אישור ושליחת בקשה' onclick={handleSendSMS} />
      </div>
    </div>
  );
};

export default SendSmsEntityPayment;
